import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createTermOrMethod.presenters.createTermOrMethodFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{name} has been created.',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Error processing the request.',
  },
})
